export default {
  GET_WITHDRAWAL_CHECK: "/api/v1/user/withdrawal",
  POST_WITHDRAWAL_PREFLIGHT: "/api/v1/user/withdrawal/preflight",
  POST_WITHDRAWAL_CONFIRM: "/api/v1/user/withdrawal/confirm",
  POST_WITHDRAWAL_DOBY_CANCELLATION: "/api/v1/user/withdrawal/doby-cancellation",
  POST_WITHDRAWAL_SURVEY: "/api/v1/user/withdrawal/survey",
  POST_WITHDRAWAL_COMMENT: "/api/v1/user/withdrawal/comment",
  POST_WITHDRAWAL_EXECUTE: "/api/v1/user/withdrawal",
  PATCH_WITHDRAWAL_CANCEL: "/api/v1/user/withdrawal",
  POST_WITHDRAWAL_BLOCK_REQUEST: "/api/v1/user/withdrawal/block-request",
};
